import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Charter } from '../../models/data/charter';
import { Owner } from '../../models/data/owner';
import { Representative } from '../../models/data/representative';
import { SearchParams } from '../../models/searchParams';
import { CharterCreateEditComponent } from '../charter-create-edit/charter-create-edit.component';
import { OwnerCreateEditComponent } from '../owner-create-edit/owner-create-edit.component';

@Component({
  selector: 'app-representative-create-edit',
  templateUrl: './representative-create-edit.component.html',
  styleUrls: ['./representative-create-edit.component.scss']
})
export class RepresentativeCreateEditComponent implements OnInit {
  public representative: Representative;
  public cities = cities;
  public countries = countries;

  @ViewChild('representativesModal') representativesModal;
  @Output() submit: EventEmitter<Representative> = new EventEmitter<Representative>();
  @ViewChild('ownerModal') ownerModal: OwnerCreateEditComponent;
  @ViewChild('charterModal') charterModal: CharterCreateEditComponent;


  modalRef: NgbModalRef;

  /*
* Owner ng select
*/
  public owners: Owner[] = [];
  public ownersLoading = false;
  // public selectedOwner;
  public ownersHasNext = true;
  public ownerParams: SearchParams = new SearchParams();
  /*
* Owner ng select
*/
  public charters: Charter[] = [];
  public chartersLoading = false;
  // public selectedCharter;
  public chartersHasNext = true;
  public charterParams: SearchParams = new SearchParams();


  constructor(private modalService: NgbModal,
    private api: MarineApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private marineAPI: MarineApiService) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(representative: Representative) {
    this.representative = Object.assign(new Representative(), representative);
    this.modalRef = this.modalService.open(this.representativesModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.representative.id) {
      this.spinner.show();
      this.api.updateRepresentative(this.representative).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createRepresentative(this.representative).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

  onScrollToEndOwners() {
    if (!this.ownersHasNext) {
      return
    }
    this.ownerParams.page++;
    this.loadOwners();
  }
  searchOwners(e) {
    this.ownerParams.search = e.term;
    if (!this.ownersLoading) {
      this.ownersLoading = true;
      setTimeout(() => {
        this.ownerParams.page = 1;
        this.owners = [];
        this.loadOwners();
      }, 1000);
    }
  }

  openOwners() {
    this.ownerParams.search = "";
    this.ownerParams.page = 1;
    this.owners = [];
    this.loadOwners();
  }
  loadOwners() {
    this.ownersLoading = true;
    this.marineAPI.getOwners(this.ownerParams).subscribe(
      r => {
        this.ownersLoading = false;
        this.ownersHasNext = r.next !== null;
        if (this.owners.length > 0) {
          this.owners = this.owners.concat(r.results);
        } else {
          this.owners = r.results;
        }
      }, errors => {
        this.ownersLoading = false;
        alert('There was a problem with fetching owners');
      }
    )
  }


  ownerSubmit(owner: Owner) {
    this.owners = this.owners.concat(owner);
    this.representative.owner = owner;
    this.ownerModal.close();
    this.toastr.success('Owner added', 'Success!');
  }
  oncloseOwnerModal() {
    document.querySelector('.modal').classList.add('d-block')
  }



  openCharters() {
    this.charterParams.search = "";
    this.charterParams.page = 1;
    this.charters = [];
    this.loadCharters();
  }
  onScrollToEndCharters() {
    if (!this.chartersHasNext) {
      return
    }
    this.charterParams.page++;
    this.loadCharters();
  }
  searchCharters(e) {
    this.charterParams.search = e.term;
    if (!this.chartersLoading) {
      this.chartersLoading = true;
      setTimeout(() => {
        this.charterParams.page = 1;
        this.charters = [];
        this.loadCharters();
      }, 1000);
    }
  }

  loadCharters() {
    this.chartersLoading = true;
    this.marineAPI.getCharters(this.charterParams).subscribe(
      r => {
        this.chartersLoading = false;
        this.chartersHasNext = r.next !== null;
        if (this.charters.length > 0) {
          this.charters = this.charters.concat(r.results);
        } else {
          this.charters = r.results;
        }
      }, errors => {
        this.chartersLoading = false;
        alert('There was a problem with fetching charters');
      }
    )
  }

  charterSubmit(charter: Charter) {
    this.charters = this.charters.concat(charter);
    this.representative.charter = charter
    this.charterModal.close();
    this.toastr.success('Charter added', 'Success!');
  }
  onCloseCharterModal() {
    document.querySelector('.modal').classList.add('d-block')
  }




  addCharterFn = (name) => {
    document.querySelector('.modal').classList.remove('d-block');
    this.addItemFn(new Charter(), name, this.charterModal, 'name');
  }

  addOwnerFn = (name) => {
    document.querySelector('.modal').classList.remove('d-block');
    this.addItemFn(new Owner(), name, this.ownerModal, 'name');
  }

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

}

